import React, { useCallback, useEffect, useState } from "react";
import clsx from "clsx";

import Text from "../../common/Text/Text";

import * as Utils from "../../../lib/util/Utils";
import * as AnalyticsUtils from "../../../lib/util/AnalyticsUtils";
import * as strings from "../../../strings";

import { useRoute } from "../../../lib/hook/NavigationHooks";

const ScrollToTop = () => {
	const scrollUp = useCallback(() => {
		Utils.scrollTo();
		AnalyticsUtils.sendEvent({
			eventCategory: "Scroll To Top",
			eventAction: "click",
			mixpanelProperties: {
				name: "Scroll To Top Click",
			},
		});
	}, []);
	const route = useRoute();
	const [visible, setVisible] = useState(false);

	const handleScroll = useCallback(() => {
		setVisible(window.scrollY > 10);
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [handleScroll]);

	if (route?.options?.noScrollToTop) {
		return null;
	}

	return (
		<div
			className={clsx(
				"ScrollToTop__wrapper --pdf-ignore",
				visible && "--visible",
			)}
		>
			<Text tag={"button"} className={"ScrollToTop__btn"} onClick={scrollUp}>
				{strings.MISC_SCROLL_TO_TOP}
			</Text>
		</div>
	);
};

export default React.memo(ScrollToTop);
